import { ReactComponent as Clock } from '@/svg/clock.svg'
import { ReactComponent as Weight } from '@/svg/weight.svg'
import { ReactComponent as Symbol } from '@/svg/jigsaw.svg'
import { ReactComponent as Document } from '@/svg/3d-document.svg'

const items: WidgetContentInterface[] = [
  {
    symbol: <Clock />,
    title: 'ประหยัดเวลาและค่าใช้จ่าย',
    content:
      'เอกสารที่ช่วยให้คุณปฏิบัติตาม PDPA ได้อย่างรวดเร็ว และประหยัดกว่าการจ้างนักกฎหมาย',
  },
  {
    symbol: <Weight />,
    title: 'หายห่วงเรื่อง PDPA',
    content:
      'ชุดเอกสารจัดทําโดยผู้เชี่ยวชาญทางกฎหมาย พร้อมอัพเดทให้คุณเมื่อกฎหมายเปลี่ยนแปลง',
  },
  {
    symbol: <Symbol />,
    title: 'ปรับแต่งได้ตามต้องการ',
    content:
      'เพิ่มโลโก้องค์กรของคุณหรือ จัดวางรูปแบบตามต้องการให้เป็นแบรนด์ของคุณเอง',
  },
  {
    symbol: <Document />,
    title: 'ง่ายต่อการใช้งาน',
    content:
      'เรามีแนวทางการใช้งานชุดเอกสารให้กับคุณ เพียงแค่ทำตามก็สามารถใช้งานได้อย่างง่ายดาย',
  },
]

export default {
  items,
}
